var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditWrapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1629",
    "data-name": "Grupo 1629",
    transform: "translate(-305 -38.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delivery-red-determined-stock-male",
    transform: "translate(305 38.768)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 54,
    height: 54,
    rx: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1624",
    "data-name": "Grupo 1624",
    transform: "translate(337.156 59.538) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_615",
    "data-name": "Ret\\xE2ngulo 615",
    width: 4.108,
    height: 13.692,
    transform: "translate(0 0)",
    fill: "#d3ff9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pol\\xEDgono_1",
    "data-name": "Pol\\xEDgono 1",
    d: "M2.054,0,4.108,2.738H0Z",
    transform: "translate(4.108 16.43) rotate(180)",
    fill: "#d3ff9a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWrapper);
export default __webpack_public_path__ + "static/media/edit-wrapper.85175e0b59b3dd98408d2825dcb2ed86.svg";
export { ForwardRef as ReactComponent };